var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: [
        "gfu-block-editor-prefix",
        { "gfu-block-editor-prefix--draggable": _vm.allowDrag },
        { _jcc: _vm.shouldCenterIcon },
      ],
      attrs: { draggable: _vm.allowDrag },
      on: { dragstart: _vm.onDragStart, dragend: _vm.onDragEnd },
    },
    [
      _vm._t("default", function () {
        return [
          _vm.allowDrag
            ? _c("span", {
                staticClass: "_fa _fa--grip-lines",
                attrs: { draggable: "false" },
              })
            : _vm._e(),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }